// TabContent1.js
import React, { useState, useEffect } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, InputBase } from '@mui/material';
import { tokens } from '../../../../../theme';
import { useDispatch } from 'react-redux';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const dispatch = useDispatch();


    const handleInput = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    return (
        <>
            <Box 
                sx={{
                    width:1,
                    display:"flex",
                    alignItems:"center",
                    paddingTop: 2,
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("firstname")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="firstname"
                        value={data.firstname ?? ""}
                        onChange={handleInput}
                        error={props.errors.firstname}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("lastname")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="lastname"
                        value={data.lastname ?? ""}
                        onChange={handleInput}
                        error={props.errors.lastname}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                    
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("emailaddress")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="email"
                        value={data.email ?? ""}
                        onChange={handleInput}
                        error={props.errors.email}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
        </>
    );
};

const AccountDetails = (props) => {
    const { t } = useTranslation();

    const conditionalSchema = [
        {
            key: "firstname",
            errorField: t('firstname'),
            alwaysRequired: true,
            type: "text",
        },
        {
            key: "lastname",
            errorField: t('lastname'),
            alwaysRequired: true,
            type: "text",
        },
        {
            key: "email",
            errorField: t('emailaddress'),
            alwaysRequired: true,
            type: "email",
        },
    ];

    return (
        <ProgressionTab
        tabId="tabAccountDetails"
        subtitle={t('account_details_portal')}
        nextTab={"tabOtherDetails"}
        step={3}
        maxSteps={4}
        conditionalSchema={conditionalSchema}
    >
        <Content />
    </ProgressionTab>
    )
}

export default AccountDetails;